import React from 'react';
import { Link } from "gatsby";
import Box from '@material-ui/core/Box';
import './ship.css';





const TheShip = (props) => {


    return(
      <>
        {props.ship}

        <svg
   
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   viewBox="0 0 26.458333 26.458334">





    <symbol id="alien_spaceship">
    <g id="alien_body">
        <path
            id="a0"
            d="M 22.048648,12.691417 A 6.8834805,5.7003822 0 0 1 15.336919,18.390024 6.8834805,5.7003822 0 0 1 8.2902581,12.975792 6.8834805,5.7003822 0 0 1 14.650341,7.0070002 6.8834805,5.7003822 0 0 1 22.014386,12.123375"
        />
        <path
            id="a1"
            d="m 21.961686,18.870441 1.061175,4.6138"
        />
        <path
            id="a2"
            d="m 13.195467,23.668792 0.322966,-3.598764"
        />
        <path
            id="a3"
            d="m 8.2125633,18.316784 -3.5064877,5.07518"
        />
        <path
        id="a4"
        d="m 8.1202873,12.042017 c -3.533215,3.851304 -1.3422901,5.309628 -0.7382079,6.828423 0.6040822,1.518795 8.4386026,2.798363 12.1342936,2.076209 0,0.29774 6.690009,-2.54394 5.213593,-5.905662 -1.277983,-2.909899 -2.71558,-2.917612 -2.71558,-2.917612 0,0 -0.523852,3.649897 -1.575254,4.394028 -1.051402,0.744131 -2.668787,2.924024 -8.397115,1.245726 C 8.5085699,16.727892 8.0909023,12.237917 8.1202873,12.042017 Z"
        />
    </g>
    </symbol>

    <symbol id="bubble_spaceship">
        <g id="bubble_fire">
            <path
                id="b1"
                d="m 17.337932,2.4094492 2.426613,-1.47813554 0.05174,1.08653264 h 1.552189 L 20.604642,5.003543 Z"
            />
           <path
                id="b2"
                d="m 24.369374,7.8126867 1.190012,-0.3104378 -1.303544,2.9704941 -2.823366,-4.1980231 2.781679,-3.0668619 -0.155219,2.2248051 1.655669,0.05174 z"
            />
            <path
                id="b3"
                d="M 18.315835,2.8456805 19.05,2.1166667 20.6375,2.38125 19.712806,3.5700356 Z"
            />
            <path
                id="b4"
                d="m 21.695833,6.35 1.852084,-1.8520833 -0.264584,2.1166666 h 1.058334 l -0.529167,3.175 z"
            />
        </g>
        <g id="bubble_rockets">
    <path
       id="b5"
       d="m 15.564562,4.5378861 c -0.54591,0.4104319 1.046041,-1.3929533 1.77337,-2.1284369 1.529077,0.6446113 2.832356,1.402121 3.26671,2.5940938 -0.873487,0.5370134 -0.651538,1.0740268 -0.760892,1.6110402 0.678981,0.4096313 1.185278,0.2148698 1.588726,-0.3398633 1.602178,1.509517 1.960461,2.811718 2.823366,4.1980231 -1.50519,1.532531 -3.010381,1.865087 -4.515571,2.335395 z"
    />
  </g>
  <g id="bubble_body">
    <ellipse
       cx="13.229167"
       cy="13.229167"
       rx="9.921875"
       ry="10.583333"
       id="b6"

       />
    <ellipse
       cx="10.915595"
       cy="13.185029"
       rx="7.3913631"
       ry="8.3003626"
       id="b7"
       />
  </g>
    </symbol>



    <symbol id="classy_spaceship">
    <g
     id="classy_body"
    >
    <path
       id="c1"
       d="m 17.163643,22.580042 c 0.115105,0 0.140685,-0.294209 0.140685,-0.422057 0,-0.149495 0.103266,-0.239448 0.140686,-0.351714 0.115913,-0.347732 -0.04033,-1.880495 -0.07034,-2.180627 -0.05349,-0.534902 -0.0996,-1.083776 -0.140686,-1.617885 -0.06815,-0.886013 0.05544,-1.785984 0,-2.673026 -0.05739,-0.918253 -0.252989,-1.841677 -0.422057,-2.74337 C 16.690649,11.944521 16.598698,11.296966 16.319532,10.692107 15.917112,9.8201966 15.112031,8.6453566 14.27959,8.159766 13.943706,7.9638333 13.531495,7.866112 13.154106,7.808052 c -0.09171,-0.01411 -0.570236,0.062854 -0.633086,0 -0.01658,-0.01658 0.01658,-0.053764 0,-0.070343 -0.02159,-0.02159 -0.366367,-0.00796 -0.422057,0 -0.316588,0.045227 -0.648505,0.2187381 -0.914456,0.351714 -0.09158,0.04579 -0.269304,0.015402 -0.351714,0.070343 -0.09755,0.065032 -0.117239,0.2110282 -0.211029,0.2813712 -0.9324028,0.6993022 -1.3859103,1.8573648 -1.8992557,2.8840548 -0.031458,0.06292 0.022244,0.144299 0,0.211029 -0.053469,0.160406 -0.2105151,0.268536 -0.2813711,0.422057 -0.4900279,1.061727 -0.6568975,2.165493 -0.9144566,3.306112 -0.2130616,0.943557 0.08315,-1.755613 -0.1406856,1.26617 -0.1471814,1.986948 -0.033113,3.965163 0.422057,5.908796 0.1641332,0.04689 -0.00459,0.02123 0.1647955,0.0424 0.736681,0.09209 1.0859844,0.429816 1.8250851,0.491406 0.7510104,0.06258 1.6000504,0.06407 2.3492514,0.145508 0.855832,0.09303 2.324449,-0.116576 3.187549,-0.116576 0.164133,0 0.336689,0.0519 0.492399,0 0.155092,-0.0517 0.323948,-0.154878 0.4924,-0.211028 0.06673,-0.02224 0.142786,0.01706 0.211028,0 0.105765,-0.02644 0.649243,-0.633086 0.773768,-0.633086"
    />
    <path
       id="c2"
       d="m 10.129365,8.7928512 c 0.211028,-0.8910089 0.348554,-1.802698 0.633085,-2.6730269 0.0011,-0.00323 0.549077,-1.1481556 0.844114,-1.2661704 0.130623,-0.052249 0.281857,0.011684 0.422056,0 0.745372,-0.062114 0.632373,-0.1237239 1.336514,0.4923997 0.297631,0.2604275 0.375349,0.2348044 0.562742,0.5627425 0.250979,0.4392128 0.349342,0.9061519 0.4924,1.406856 0.07855,0.2749246 0.37723,0.6392899 0.4924,0.9847995 0.04012,0.1203722 0.337247,0.622445 0.337247,0.7400169"
/>
    <path

       id="c3"
       d="m 12.52102,10.692107 c -0.95457,0.03871 -1.908827,0.95076 -2.039941,1.969599 -0.08679,0.674419 0.52139,1.031859 1.177533,1.477199 0.174619,0.118518 0.972538,0.422057 1.284465,0.422057 0.97099,0 1.341848,-0.522758 1.406856,-1.406856 0.04935,-0.671074 0.0351,-1.321025 -0.4924,-2.039942 -0.22195,-0.302489 -0.969033,-0.422057 -1.336513,-0.422057"
    />
    <path
       id="c4"
       d="m 17.304331,16.53056 c 1.945764,2.238435 3.746277,4.594569 4.079883,7.597024 0.01976,0.177868 0.160888,1.105283 0.07034,1.195828 -0.03316,0.03316 -0.09874,-0.02097 -0.140686,0 -0.04689,0.02345 -0.122773,0.140685 -0.07034,0.140685 0.02345,0 0.02345,-0.07034 0,-0.07034 -0.03316,0 -0.0469,0.04689 -0.07034,0.07034 -1.146937,-0.236155 -1.918607,-0.755688 -2.673029,-1.617884 -0.164133,-0.187581 -0.368736,-0.346332 -0.492399,-0.562743 -0.16902,-0.295784 -0.329415,-0.751471 -0.562743,-0.984799 -0.09379,-0.09379 -0.201789,0.175259 -0.281374,0.281371"
/>
    <path

       id="c5"
       d="m 7.2453094,16.53056 c -1.5482424,2.560802 -3.3061121,4.952937 -3.3061121,8.01908 0,0.447971 0.00891,0.650905 0.2110285,1.055143 0.8651698,0 1.0528172,-0.07014 1.2661706,-0.18309 0.2133534,-0.112952 0.8348646,-0.59765 1.0262102,-0.744839 0.3612078,-0.277852 0.5758949,-0.914787 0.8027029,-1.323041 0.081429,-0.146573 0.5627424,-1.604409 0.5627425,-0.914457 0.1164713,0.492323 -0.099174,1.051673 0,1.547542 0.047604,0.238019 1.7782139,0.281372 1.8992559,0.281372 0.121042,0 1.8171771,0.01705 2.8195281,0.0607 1.002352,0.04365 2.737468,-0.05995 3.581668,-0.0607 0.572068,0 0.401198,-0.04948 0.773771,-0.422057 0.267024,-0.267025 0.407479,-1.976571 0.322857,-1.540281 -0.08928,0.460292 -9.3715946,0.842154 -9.39708,0.133424"
    />
  </g>

    </symbol>
  

    <symbol id="space_shuttle">
    <g id="shuttle_ET">
        <path
            id="d1"
            d="M 9.2604166,21.166666 V 5.2916666 c 0.8054604,-1.7664509 2.4566144,-2.8080214 3.9687504,-3.96875 1.576988,1.1253057 3.304076,2.1338662 3.968749,3.96875 V 21.166666 c -2.030024,0.576916 -4.697396,0.855109 -7.9374994,0 z"
        />
    </g>
    <g id="shuttle_SRBs">
        <path
            id="d2"
            d="M 9.2604166,23.8125 H 6.6145832 V 7.9374999 L 7.9374999,5.2916666 9.2604166,7.9374999 Z"
        />
        <path
            d="M 19.84375,23.8125 H 17.197917 V 7.9375 L 18.520833,5.2916668 19.84375,7.9375 Z"
            id="d2" 
        />
    </g>
    <g id="shuttle_body">
        <path
            id="d4"
            d="M 6.6145833,21.166667 H 19.84375 C 18.629486,20.569568 17.354373,20.024625 17.197917,18.520833 L 15.875,7.9375 C 15.208707,6.0657855 15.044911,3.9428224 13.229167,2.6458333 10.860869,4.1810525 11.062816,6.1116939 10.583333,7.9375 L 9.2604167,18.520833 c -0.2125984,1.328175 -1.5508752,1.905898 -2.6458334,2.645834 z"
 />
    </g>
    <g id="shuttle_windows">
        <path
            id="d5"
            d="m 11.377083,5.2916666 1.5875,1e-7 v -2.38125 c -0.162335,0.1267748 -1.517358,1.7440244 -1.5875,2.3812499 z"

            />
        <path
            id="d6"
            d="M 14.816666,5.2916666 H 13.49375 V 3.175 c 0.564118,0.3508794 1.041288,0.9521779 1.322916,2.1166666 z"

            />
        <path
            transform="scale(0.26458333)"
            id="d7"
            d="m 51.569318,16.295009 c 0,-3.593762 -0.05707,-3.406668 0.769535,-2.522964 0.664417,0.710316 1.237106,1.531149 1.707109,2.446797 0.435078,0.847608 1.036566,2.376584 1.154412,2.934505 l 0.06479,0.306737 h -1.847923 -1.847923 z"
        />
    </g>
    <g id="shuttle_logos">
        <circle
            r="1.058333"
            cx="10.583333"
            cy="19.579166"
            id="d8"

            />
        <rect
            y="18.520834"
            x="14.2875"
            height="1.8520819"
            width="2.6458325"
            id="d8"
        />
        <text
            id="d10"
            y="19.314583"
            x="9.7895832"
            >
            <tspan
                style={{fontSize:"1.41111px", strokeWidth:"0.264583"}}
                y="19.314583"
                x="9.7895832"
                id="tspan928"
            />
        </text>
        <g
            transform="matrix(0.05579386,0,0,0.0702696,9.1857202,18.46793)"
             id="d11"
            aria-label="NASA">
            <path
                className="d12"
                d="M 16.693533,19.579166 H 15.427464 L 11.77912,12.695888 v 6.883278 H 10.823109 V 11.88457 h 1.586461 l 3.327952,6.283834 V 11.88457 h 0.956011 z" />
            <path
                className="d12"
                d="m 24.806707,19.579166 h -1.09037 l -0.754473,-2.144565 h -3.327952 l -0.754473,2.144565 H 17.840746 L 20.6416,11.88457 h 1.364253 z M 22.646639,16.556105 21.297888,12.77857 19.94397,16.556105 Z" />
            <path
                className="d12"
                d="m 31.565962,17.382925 q 0,0.449584 -0.211872,0.888832 -0.206705,0.439248 -0.583942,0.744138 -0.41341,0.330728 -0.966346,0.516763 -0.547769,0.186034 -1.322913,0.186034 -0.831988,0 -1.498612,-0.155028 -0.661456,-0.155029 -1.34875,-0.459919 v -1.281572 h 0.07235 q 0.583941,0.485757 1.34875,0.749306 0.764809,0.263549 1.4366,0.263549 0.950844,0 1.477942,-0.356566 0.532265,-0.356566 0.532265,-0.950843 0,-0.511595 -0.253213,-0.754474 -0.248047,-0.242878 -0.759642,-0.377237 -0.387572,-0.103352 -0.842323,-0.170531 -0.449583,-0.06718 -0.956011,-0.170532 -1.02319,-0.21704 -1.519282,-0.738971 -0.490925,-0.527098 -0.490925,-1.369421 0,-0.966346 0.816485,-1.581294 0.816486,-0.620115 2.072219,-0.620115 0.811317,0 1.488276,0.155029 0.676959,0.155029 1.19889,0.382404 v 1.209225 h -0.07235 q -0.439248,-0.372069 -1.157548,-0.614948 -0.713133,-0.248046 -1.462439,-0.248046 -0.821652,0 -1.322912,0.341064 -0.496092,0.341063 -0.496092,0.878496 0,0.48059 0.248046,0.754474 0.248046,0.273884 0.873329,0.418578 0.330728,0.07235 0.940508,0.175699 0.60978,0.103352 1.033525,0.211873 0.857826,0.227375 1.291907,0.687294 0.43408,0.459919 0.43408,1.286739 z" />
            <path
                className="d12"
                d="m 39.27606,19.579166 h -1.090369 l -0.754473,-2.144565 h -3.327952 l -0.754474,2.144565 h -1.038693 l 2.800854,-7.694596 h 1.364254 z m -2.160068,-3.023061 -1.34875,-3.777535 -1.353918,3.777535 z" />
        </g>

    <path
       id="d13"
       d="m 15.345833,18.785416 c 1.5875,0 1.5875,0 1.5875,0"
       />
    <path
       d="m 15.345833,19.314583 c 1.5875,0 1.5875,0 1.5875,0"
       id="d14" />
    <path
       d="m 14.2875,19.880161 c 2.645833,0 2.645833,0 2.645833,0"
       id="d15" />
    <path
       id="d16"
       d="m 14.2875,19.05 h 1.058333"
       />
  </g>

 
    </symbol>

 
  
    <use href={props.ship} />

</svg>
      </>
    )


    }

export default TheShip;




